import { type Warehouse } from "@/entities/warehouse";

export const mockWarehouses: Warehouse[] = [
  {
    id: "wh-1",
    accountId: "1",
    name: "Hauptlager Mannheim",
    street: "Industriestraße 15",
    zip: "68169",
    city: "Mannheim",
    country: "Deutschland",
    isDefault: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "wh-2",
    accountId: "1",
    name: "Ersatzteillager Backstube",
    street: "Industriestraße 15",
    zip: "68169",
    city: "Mannheim",
    country: "Deutschland",
    isDefault: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "wh-3",
    accountId: "1",
    name: "Außenlager Heidelberg",
    street: "Bergheimer Straße 50",
    zip: "69115",
    city: "Heidelberg",
    country: "Deutschland",
    isDefault: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
